import type { QuizMaterialResponse } from '../models/quiz';
import type { QuizMode } from '../services/quiz/quiz';

type MaterialKind = QuizMaterialResponse['materialKind'];

export function questionIconFor(materialKind: MaterialKind): string {
  if (materialKind === 'quiz') return 'quiz';
  if (materialKind === 'annotation') return 'sticky_note';
  if (materialKind === 'voice') return 'mic';
  return 'question';
}

export function quizModeFor(materialKind: MaterialKind): QuizMode {
  if (materialKind === 'annotation') return 'note';
  if (materialKind === 'voice') return 'voice';
  if (materialKind === 'multi' || materialKind === 'simple') return 'question';
  return 'quiz';
}
